import { useEffect, useState } from "react";
import { getValidPath } from "@lib/utils/breadcrumbsUtility";
import type { pagePathData } from "@store/types";

export type BreadcrumbItem = { label: string; link: string };

const loadPagePaths = (): Promise<pagePathData> =>
    import("../../../../../scripts/contentful/page-paths.json").then(
        (mod) => mod.default as pagePathData
    );

type UseBreadcrumbItemsOptions = {
    pathSegments: string[];
    locale: string;
    trailing?: BreadcrumbItem;
};

export function useBreadcrumbItems({
    pathSegments,
    locale,
    trailing,
}: UseBreadcrumbItemsOptions): BreadcrumbItem[] {
    const [items, setItems] = useState<BreadcrumbItem[]>([]);

    useEffect(() => {
        let cancelled = false;
        loadPagePaths().then((pagePaths) => {
            if (cancelled) return;
            const validPath = getValidPath(pagePaths, pathSegments, locale);
            setItems(trailing ? [...validPath, trailing] : validPath);
        });
        return () => {
            cancelled = true;
        };
    }, [pathSegments.join("/"), locale, trailing?.label]);

    return items;
}
